import React, { useState, useEffect } from "react";
import { MessageFactory } from "../../../lib/messages";
import { Protocol } from "../../../lib/constants";
import {
  OPContainer,
  OPBox,
  OPHeader,
  OPWrapper,
} from "../settings/SettingsStyled";
import { Title, Button, SeedInput, Description } from "./ProvFairStyled";
import Detailed from "./ProvFairDetailed";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";

export default ({
  pf,
  Globals,
  handleNotification,
  handleAbove,
  isClickable,
  isAutoOn,
  aboveAnim,
  handleAboveAnim,
  handleSettingsOut,
  audio,
}) => {
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256,
  } = pf;
  const [inputSeed, setinputSeed] = useState("");
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [btnAnimation, setBtnAnimation] = useState(false);
  const [seedError, setSeedError] = useState(false);

  const ProvFairTitle = {
    Title: "Explanation",
    Description: ` There are several implementations of the provably fair method, we
    will describe the most common one. With this method each roll-result
    is calculated by the following variables:`,
  };
  const ProvFairText = [
    {
      Title: "Serverseed",
      Description: `provided by the gambling site`,
    },
    {
      Title: "Nonce",
      Description: ` A number that increases with each random number is needed.`,
    },
    {
      Title: "Clientseed",
      Description: `provided by your browser and adjusted by you`,
    },
    {
      Title: "Hash",
      Description: `Encrypted data`,
    },
  ];

  const changeHandler = (e) => {
    let val = e.target.value;
    const onlyLatinCharacters = /^[A-Za-z0-9]+$/;
    if (onlyLatinCharacters.test(val) || val === "") {
      setinputSeed(val);
    }
    if (val.length >= 16 && val.length <= 128) {
      setSeedError(false);
      handleNotification(false);
    }
  };

  const submit = () => {
    if (inputSeed.length >= 16 && inputSeed.length <= 128) {
      audio.setSeed();
      Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.SET_SEED, inputSeed)
      );
      handleNotification(false);
      setSeedError(false);
      setinputSeed("");
    } else {
      setSeedError(true);
      handleNotification(
        "Length of the seed must be minimum 16 and maximum 128 symbols"
      );
    }
  };

  useEffect(() => {
    Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.GET_SEEDS));
  }, [Globals.WS]);

  //  copy to clipboard

  const copyToClipboard = (e) => {
    e.target.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };

  const VfCheck = () => {
    window.open('https://codepen.io/orbitalgaming/pen/QWoEQLm', '_blank')
  }
  return (
    <OPContainer
      aboveAnim={aboveAnim}
      className="prov"
      isDisabled={soundPlayed}
    >
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <OPHeader aboveAnim={aboveAnim} close={btnAnimation === "close"}>
            <p>Prov. Fair</p>
            <span
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => {
                setBtnAnimation("close");
                handleAboveAnim(false);
                setSoundPlayed(true);
                audio.goBack();
                setTimeout(() => {
                  handleAbove(false);
                  handleSettingsOut(false);
                }, 550);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <Title>
            <h4>Clients seed</h4>
            <textarea
              onClick={(e) => copyToClipboard(e)}
              value={client_seed ? client_seed : "client seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title>
            <h4>Server seed hash</h4>
            <textarea
              onClick={(e) => copyToClipboard(e)}
              value={server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={nonce === 0 || nonce === ""}>
            <h4>Nonce</h4>
            <textarea
              onClick={(e) => nonce !== "" && nonce !== 0 && copyToClipboard(e)}
              value={nonce}
              spellCheck="false"
              readOnly="readOnly"
              className="nonce"
            />
          </Title>
          <Title>
            <h4>Next server seed hash</h4>
            <textarea
              onClick={(e) => copyToClipboard(e)}
              value={next_server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
            onClick={() =>
              (!isClickable || isAutoOn) &&
              handleNotification("You can't change the seed while round is active")
            }
          >
            <SeedInput
              name="input"
              placeholder="New seed"
              spellCheck="false"
              onChange={changeHandler}
              value={inputSeed}
              notify={seedError}
              clickable={!isClickable}
              autoOn={isAutoOn}
            />
            <Button
              setA={btnAnimation === "submit"}
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => {
                setBtnAnimation("submit");
                setTimeout(() => {
                  submit();
                }, 167);
              }}
              clickable={!isClickable}
              autoOn={isAutoOn}
            >
              set
            </Button>
          </form>
          <Title>
            <h4>Previous seed pair</h4>
          </Title>
          <Title copyCursor={old_client_seed === ""}>
            <h4>Clients seed</h4>
            <textarea
              onClick={(e) => old_client_seed !== "" && copyToClipboard(e)}
              value={old_client_seed !== "" ? old_client_seed : "client seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed === ""}>
            <h4>Server seed</h4>
            <textarea
              onClick={(e) => old_server_seed !== "" && copyToClipboard(e)}
              value={old_server_seed !== "" ? old_server_seed : "server seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed_SHA256 === ""}>
            <h4>Server seed hash</h4>
            <textarea
              onClick={(e) =>
                old_server_seed_SHA256 !== "" && copyToClipboard(e)
              }
              value={
                old_server_seed_SHA256 !== ""
                  ? old_server_seed_SHA256
                  : "server seed hash"
              }
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_nonce === 0 || old_nonce === ""}>
            <h4>Nonce</h4>
            <textarea
              onClick={(e) =>
                old_nonce !== "" && old_nonce !== 0 && copyToClipboard(e)
              }
              value={old_nonce}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Button className={old_client_seed === "" || old_client_seed === undefined ? 'disabled':''}  onClick={() => VfCheck()}>Verify</Button>
          <Description>
            <h3>{ProvFairTitle.Title}</h3>
            <p>{ProvFairTitle.Description}</p>
          </Description>
          {ProvFairText.map((item, id) => (
            <Description key={id}>
              <h4>{item.Title}</h4>
              <p>{item.Description}</p>
            </Description>
          ))}
          <Detailed />
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
